import { IServiceResult, IUser, IUserProfile } from "../Models/Models";

export interface IUserProfileAxios {
  UpdateUserProfile(
    profileUpdateObj: IUserProfile
  ): Promise<IServiceResult<IUser>>;
  UpdateUserAvatar(avatarImg: File): Promise<IServiceResult<string>>;
  DeleteUserAvatar(avatarStr: string): Promise<IServiceResult<boolean>>;
}
